<script setup lang="ts">
import { Ref, ref } from 'vue'

import Spinner from '@ankor-io/blocks/components/Spinner/Spinner.vue'
import { Proposal } from '@ankor-io/common/proposal/Proposal'

import ProposalViewer from '@/components/ProposalViewer.vue'
import { WaveService, useWaveService } from '@/services/wave/WaveService'

export interface Props {
  bookingId: string
}

const props = defineProps<Props>()
const fetchingProposal: Ref<boolean> = ref(true)
const proposal: Ref<Proposal | null> = ref(null)
const waveService: WaveService = useWaveService()

// use the booking id to load the proposal
waveService.getProposal(props.bookingId).then((_proposal: Proposal | null) => {
  fetchingProposal.value = false
  proposal.value = _proposal
})
</script>
<template>
  <div v-if="fetchingProposal" class="flex items-center justify-center h-full">
    <Spinner />
  </div>
  <div v-else>
    <ProposalViewer
      v-if="proposal"
      :proposal="proposal!"
      :style="{ background: proposal?.template.theme.color.background || '#ffffff' }"
    ></ProposalViewer>
    <div v-else>Presentation not found</div>
  </div>
</template>
